// extracted by mini-css-extract-plugin
var _1 = "EditorBlock_active__980e3";
var _2 = "EditorBlock_block__0ec9c";
var _3 = "EditorBlock_comment__d60f7";
var _4 = "EditorBlock_commentActive__931a0";
var _5 = "EditorBlock_comments__124ae";
var _6 = "EditorBlock_commentsDeep__f4984";
var _7 = "EditorBlock_divider__e6db7";
var _8 = "EditorBlock_icons__336f5";
var _9 = "EditorBlock_root__0e38a";
var _a = "EditorBlock_task__34d55";
var _b = "EditorBlock_tooltipPortal__cb925";
var _c = "EditorBlock_waiting__50aa6";
var _d = "EditorBlock_wrapper__41db2";
export { _1 as "active", _2 as "block", _3 as "comment", _4 as "commentActive", _5 as "comments", _6 as "commentsDeep", _7 as "divider", _8 as "icons", _9 as "root", _a as "task", _b as "tooltipPortal", _c as "waiting", _d as "wrapper" }
